import {React, useState, useEffect} from 'react';

export default function Frontpage() {
    const screenWidth = window.innerWidth;
    const [showMore, setShowMore] = useState(false);

    useEffect(() => {
        if (screenWidth > 991) {
            setShowMore(true)
        } else {
            setShowMore(false);
        }
    }, [])

    
    let text = 'Kirppis Ruusunen on palvellut vuodesta 2013. Sijaitsemme vilkkaan kantatien vieressä Ylivieskassa Savarissa ja meillä on runsaasti parkkitilaa. \n Myyntipaikkoja on 302, joista teet ihania kirppislöytöjä mm. Retroa ja vanhaa tavaraa, kotimaista lasia ja lp-levyjä. Myynnissä on myös huonekaluja, kirjoja, postikortteja, adresseja, työkaluja  ja käsitöitä. \n Tuoreita kotileivonnaisia on myynnissä päivittäin. Kirpputorillamme on pieni kahvio, sekä leikkipaikka. \n \n Tervetuloa siistiin ja palvelevaan Kirppis Ruususeen! Avoinna joka päivä (huom.juhlapyhät). \n';
    return (
        <div className="bannerKuva">
            <div className="bannerOverlay">
                <div className="picture_for_mobile">
                <section className="esittelyteksti p-4 px-2 px-sm-4 pb-1 pb-sm-4 ps-lg-4 pe-lg-0">
                    <h1 className="pb-1 text-center">Tervetuloa Kirppis Ruususeen!</h1>
                    <p className="px-4 pt-4 new-line">
                        {showMore ? text : `${text.substring(0, 356)}`}
                        {showMore ? '' : <i style={{fontSize:"2.5em"}}>...</i>}
                        <br />
                        <span className={"videoNappi naytalisaa text-center fw-bold mx-4" + `p ${showMore ? "mt-0" : "mt-4"}`} onClick={() => setShowMore (!showMore)}>{showMore? "Näytä vähemmän" : "Näytä lisää"}</span></p>
                    <p className="mt-0 text-center"><a href="https://youtu.be/CiYrjalXm2I" target="_blank" rel="noreferrer" className="mb-2 fw-bold videoNappi"><i className="far fa-arrow-alt-circle-right me-1"></i>Katso esittelyvideo</a></p>
                    

                </section>
                </div>
                <section className="poytavaraus">
                        <div className="poytavaraus_1 my-lg-auto">
                            <div>
                            <h2>Myyntipöytä</h2>
                            <h5>2 Hyllytasoa & Vaaterekki</h5>
                            <h5 className="text-muted">110 x 80cm</h5>
                            <h5 className="text-muted">29€ / viikko</h5>
                            <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                            <button className="btn btn-primary varaus_painike1 m-1">KIRJAUDU</button>
                            </a> <br />
                            <a href="https://www.kirpparikalle.net/sovellus/guest.php?page=rekisteroidy&company_id=64" target="_blank" rel="noreferrer">
                            <button className="btn btn-primary varaus_painike1 m-1">REKISTERÖIDY</button>
                            </a>
                            </div>
                        </div>

                        <div className="poytavaraus_2 mx-4 mx-md-0 mx-md-3">
                            <img className="px-4 px-lg-0 img-fluid pb-1 " src={require("../img/kirppari_kalle.png").default} alt="Kirppari Kallen logo" />
                            <h3 className="px-2 px-sm-0">Pöytävaraus tapahtuu KirppariKallen kautta!</h3>
                        </div>
                </section>
            </div>
        </div>
    )
}
